import * as React from 'react';
import { createChatBotSession, getChatBotAnswer } from '../../services/knowledgebaseService';

import TextareaAutosize from 'react-textarea-autosize';
import { uuidv4 } from '../../utils/commonUtils';
import { CurrentUser } from '../../services/appConfig';
import { ChatBotCustomizeData } from '../../types/knowledgebase.type';
import ChatBotLauncher from '../../containers/ChatBotLauncher/ChatBotLauncher';
import { Heading,Text, Box } from '@chakra-ui/react';
import ReactMarkdown from 'react-markdown';
import ChakraUIRenderer from 'chakra-ui-markdown-renderer'
import { markdownTheme } from '../../theme/markdownTheme'
export interface ChatBotProps {
	customStyle: ChatBotCustomizeData,
	knowledgeBaseId: string,
	showCloseButton?: boolean,
	showLauncher?: boolean,
	height?: number | string,
	defaultMessageNumber: number,
}

const maxMessages = 20;

const getMessageClassName = (type: string) => {
	if(type === 'bot') {
		return 'chat-message chatbot'
	} else if(type === 'bot-error') {
		return 'chat-message chatbot-error'
	} else {
		return 'chat-message user'
	}
}
const getMessageStyle = (type: string, customStyle: { backgroundColor: string; fontColor: string }) => {
	if(type === 'bot') {
		return {}
	} else if(type === 'bot-error') {
		return { backgroundColor: 'rgb(255 205 205)', color: '#000' }
	} else {
		return { backgroundColor: customStyle.backgroundColor, color: customStyle.fontColor }
	}
}


export const ChatBot = ({
	customStyle,
	knowledgeBaseId,
	defaultMessageNumber = 0,
	showCloseButton = true,
	showLauncher = true,
	height = '520px',
}: ChatBotProps) => {

	const user = CurrentUser.get();

	const [sessionId, setSessionId] = React.useState<string>('');
	const [numberOfMessagesLeft, setNumberOfMessagesLeft] = React.useState<number>(maxMessages - defaultMessageNumber);

	const [messages, setMessages] = React.useState<any[]>([
		{
			type: 'bot',
			id: uuidv4(),
			message: customStyle?.welcomeMessage || 'Hello! How can I assist you today?',
		}
	]);

	const [question, setQuestion] = React.useState<string>('');

	// submit form on ctrl+ enter

	

	// const han

	// onEnterPress = (e) => {
	// 	if(e.keyCode == 13 && e.shiftKey == false) {
	// 	  e.preventDefault();
	// 	  this.myFormRef.submit();
	// 	}
	//   }


	const handleChatChange = React.useCallback((e: React.ChangeEvent<HTMLTextAreaElement>) => {
		console.log('e', e.target.value);
		setQuestion(e.target.value)
	}, []);
	

	const handleSubmit = React.useCallback(async (e) => {

		
		setQuestion('')
		const newMessages = [...messages, { type: 'user', message: question, id: uuidv4(), }, {type: 'bot', isLoading: true, id: uuidv4(),}]
		setMessages(newMessages)
		let newSessionId = sessionId;
		if(!sessionId) {
			try {
				const res = await createChatBotSession(knowledgeBaseId);
				console.log('res', res);
				newSessionId = res.data as unknown as string;
				setSessionId(res.data as unknown as string)
			} catch (error) {
				console.log('Unable to create session', error);
			} finally {
			}
		}

		try {
			const response = await getChatBotAnswer(newSessionId, question);
			setNumberOfMessagesLeft(numberOfMessagesLeft - 1);
			const messagesToUpdate = newMessages.filter(message => !message.isLoading);
			const responseData = response.data as any;

			if(responseData?.response) {
				setMessages([...messagesToUpdate, { type: 'bot', message: responseData?.response, id: uuidv4(), }])
			} else if(typeof responseData === 'string' && responseData.trim() === 'Sorry I cannot respond right now')  {
				setMessages([...messagesToUpdate, { type: 'bot-error', message: 'You have exceeded token limit. Please upgrade to a higher plan.', id: uuidv4(), }])
			}
	
		} catch (error) {
			const messagesToUpdate = newMessages.filter(message => !message.isLoading);
			const message = 'Oops! Unfortunately, I\'m unable to answer right now. Please use the Offline Messages if possible.';
			setMessages([...messagesToUpdate, { type: 'bot', message: message, id: uuidv4(), }])
		}
		
	}, [knowledgeBaseId, messages, numberOfMessagesLeft, question, sessionId])

	const handleKeyDown = (e: React.KeyboardEvent<HTMLTextAreaElement>) => {
		if (e.key === "Enter" || e.keyCode  === 13) {
			e.preventDefault();
			const target = e.target as HTMLTextAreaElement;
			if(target.value) {
				handleSubmit(e);
			}
		}
	}
	return (
		<div className="chat-wrap widget-open" id="chat-wrap">


			<div className="chat-widget" style={{ borderRadius: customStyle.borderRadius, height: height, minHeight:"410px" }}>
				<Box className="chat-header"  bgColor={customStyle.backgroundColor} color={customStyle.fontColor} >
					{showCloseButton &&<Box className="chat-close">
						<Box className="chat-close-btn" id="chat-close-btn">
							<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-x">
								<line x1="18" y1="6" x2="6" y2="18"></line>
								<line x1="6" y1="6" x2="18" y2="18"></line>
							</svg>
						</Box>
					</Box>}
					<Heading>
						{customStyle.heading}
					</Heading>
					<Text dangerouslySetInnerHTML={{ __html: customStyle.description }}></Text>
				</Box>
				<div id="chat-messages" className="chat-messages">
					{messages.map((message, index) => {
						
						const style = getMessageStyle(message.type, customStyle)

						const className = getMessageClassName(message.type);

						if (message.isLoading) {
							return <div className={className} key={message.id} >
								<div className="chat-message-text" style={style}>
									<div className='chat-loading-dot-cont'>
										<div className="chat-loading-dot" style={{ backgroundColor: customStyle.backgroundColor}}></div>
										<div className="chat-loading-dot" style={{ backgroundColor: customStyle.backgroundColor}}></div>
										<div className="chat-loading-dot" style={{ backgroundColor: customStyle.backgroundColor}}></div>
									</div>
								</div>
								
							</div>
						}

						return <div className={className} key={message.id}>
							<div className="chat-message-text" style={style}>
								<ReactMarkdown components={ChakraUIRenderer(markdownTheme)} >{message.message}</ReactMarkdown>
							</div>	
						</div>
					})}
				</div>
				<Box className="chat-input-wrap">
					{/* {user && user?.subscriptionData?.name === 'FREE' && <div className='chat-message-warning'>{numberOfMessagesLeft} messages left</div>} */}
					<TextareaAutosize value={question} onChange={handleChatChange} onKeyDown={handleKeyDown} rows={1} className="chat-input textarea js-auto-size" id="chat-input" placeholder="Type your message" />
					<button onClick={handleSubmit}  className="chat-submit-btn" type="submit"><svg width="16" height="16" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path fillRule="evenodd" clipRule="evenodd" d="M4.394 14.7L13.75 9.3c1-.577 1-2.02 0-2.598L4.394 1.299a1.5 1.5 0 00-2.25 1.3v3.438l4.059 1.088c.494.132.494.833 0 .966l-4.06 1.087v4.224a1.5 1.5 0 002.25 1.299z" style={{ fill: customStyle.backgroundColor }}></path>
					</svg></button>
				</Box>				
			</div>
			{showLauncher && <ChatBotLauncher backgroundColor= {customStyle.backgroundColor} fontColor= {customStyle.fontColor} />}
			
		</div>
	);
};
